import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';

import { Assessment, AssessmentSequence, UserAssessment } from './_types';
import { AssessmentSequenceListItem } from './assessment';

export const normalizeAssessment = (assessment: any): Assessment => {
  const normalizedAssessment = camelcaseKeys(assessment, { deep: true });

  // its a typo in the API
  normalizedAssessment.enableAssessementAnswerCheck =
    normalizedAssessment.enableAssessementAnswerCheck ||
    normalizedAssessment.enableAssessementAnswerCheck;

  // Ensure fields are properly normalized
  normalizedAssessment.fields = (normalizedAssessment?.fields || []).map(
    (field: any) => {
      // Keep the 'type' property as is (don't camelCase it)
      const { type } = field;
      const normalizedField = camelcaseKeys(field, { deep: true });
      normalizedField.type = type;
      return normalizedField;
    }
  );

  return normalizedAssessment as Assessment;
};

export const denormalizeAssessment = (assessment: Assessment): any => {
  return decamelizeKeys(
    {
      ...assessment,
      // its a typo in the API
      enableAssessementAnswerCheck: assessment.enableAssessementAnswerCheck,
    },
    { deep: true }
  );
};

export const normalizeAssessmentSequence = (
  assessmentSequence: any
): AssessmentSequence => {
  const normalizedAssessmentSequence = camelcaseKeys(assessmentSequence, {
    deep: true,
  });

  // Ensure groupingItems are properly normalized
  normalizedAssessmentSequence.groupingItems =
    normalizedAssessmentSequence.groupingItems.map((item: any) => {
      const { groupableType } = item;
      const normalizedItem = camelcaseKeys(item, { deep: true });
      normalizedItem.groupableType = groupableType;
      return normalizedItem;
    });

  return normalizedAssessmentSequence;
};

export const normalizeUserAssessment = (assessment: any): UserAssessment => {
  const normalizedAssessment = camelcaseKeys(assessment, { deep: true });

  // Ensure results are properly normalized
  normalizedAssessment.results = normalizedAssessment.results.map(
    (result: any) => {
      const { type } = result;
      const normalizedResult = camelcaseKeys(result, { deep: true });
      normalizedResult.type = type; // Keep the 'type' property as is
      return normalizedResult;
    }
  );

  // Extract leadName from results
  const nameResult = normalizedAssessment.results.find(
    (r: any) => r.label && r.label.match(/name?|Name/i)
  );
  normalizedAssessment.leadName = nameResult?.value || '';

  // Extract leadEmail from results
  const emailResult = normalizedAssessment.results.find(
    (r: any) => r.label && r.label.match(/email address?|Email/i)
  );
  normalizedAssessment.leadEmail = emailResult?.value || '';

  return normalizedAssessment as UserAssessment;
};

export const normalizeAssessmentSequenceList = (
  assessmentSequenceList: any
): AssessmentSequenceListItem => {
  return {
    id: assessmentSequenceList['groupings.id'],
    name: assessmentSequenceList['groupings.name'],
  };
};
